<script setup>
import GridList from '../others/GridList.vue'
import { ref } from 'vue'
import SlideDetailView from '../others/SlideDetailView.vue'
import DrinkDetails from '../drinks/DrinkDetails.vue'
import DrinkEditor from '../drinks/DrinkEditor.vue'
import { cloneDeep } from 'lodash-es'
import ActionTrigger from '@/features/data/presentation/components/ActionTrigger.vue'
import { EVENTS } from '@/shared/constants/commons'
import Events from '@/events/events'
import Commons from '@/shared/utils/commons'

const cols = [
  {
    name: 'Nom',
    id: 'name',
    image(el) {
      return el.image
    },
    value(el) {
      return [el.name || '-']
    },
  },
  {
    name: 'Prix',
    id: 'price',
    value(el) {
      return Commons.formatNumber(el.price || 0, { suffix: ' FCFA' })
    },
  },
  {
    name: '',
    id: 'action',
    icon: () => '/images/icons/eye.png',
    onClick(el) {
      detailData.value = cloneDeep(el)
    },
    value() {},
  },
]

const buttons = [
  {
    title: '&plus; Ajouter',
    onClick() {
      detailData.value = {}
      editDrink.value = true
    },
  },
]

const detailData = ref(null)
const editDrink = ref(false)
const saveDrink = ref(false)

async function deleteDrink(data) {
  const res = await window.customPrompt({
    title:
      'Voulez-vous vraiment supprimer la boisson ' +
      data.title +
      ' ? Vous ne pourrez plus la récupérer.',
    formFields: [],
    successText: 'Supprimer',
    cancelText: 'Retour',
  })

  if (!res.accepted) return
  saveDrink.value.trigger({ id: data.id, action: 'delete' })
}
</script>

<template>
  <div class="p-5 h-full overflow-auto">
    <GridList
      title="Boissons"
      dataKey="drinks"
      hasSearch
      :cols="cols"
      :buttons="buttons"
      :cardConfig="{
        imageField: 'image',
        titleField: 'name',
        priceField: 'price',
      }"
      :gridCols="{ sm: 1, md: 2, lg: 3, xl: 4 }"
    ></GridList>
  </div>

  <SlideDetailView :isVisible="!!detailData?.id" @hide="detailData = null">
    <div class="flex gap-4 absolute right-14 top-4">
      <button
        class="buttonComponent small border rounded-xl bg-red-500"
        @click="deleteDrink(detailData)"
      >
        Supprimer
      </button>
      <button
        class="buttonComponent small border rounded-xl"
        @click="editDrink = true"
      >
        Modifier
      </button>
    </div>
    <DrinkDetails v-if="detailData?.id" :drinkData="detailData" />
  </SlideDetailView>

  <SlideDetailView
    :isVisible="!!detailData && editDrink"
    @hide="editDrink = false"
  >
    <DrinkEditor
      v-if="detailData"
      :drinkData="detailData"
      @saved="editDrink = false"
    />
  </SlideDetailView>

  <ActionTrigger
    dataKey="saveDrink"
    ref="saveDrink"
    @success="detailData = null"
    @failed="
      err => {
        Events.dispatch(EVENTS.TOAST_NOTIFICATION_REQUESTED, {
          title: 'Échec de suppression',
          body: `${err.result?.message || 'Erreur non détectée'}`,
        })
      }
    "
  />
</template>
